<template>
  <div class="pointsRule_management">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="积分规则" name="first">
        <div class="serach">
          <el-row>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span class="serach-title">用户角色:</span>
                <el-select
                  v-model="queryParams.CustomType"
                  placeholder="请选择用户角色"
                  style="width: 200px; margin-right: 30px"
                >
                  <el-option
                    v-for="item in useRole"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <span class="serach-title">用户行为:</span>
                <el-select
                  v-model="queryParams.BehaviorType"
                  placeholder="请选择用户行为"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in userBehaviorList"
                    :key="item.BehaviorTypeID + item.BehaviorTypeName"
                    :label="item.BehaviorTypeName"
                    :value="Number(item.BehaviorTypeID)"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="8" class="erarcb-button">
              <el-button type="primary" @click="getList">筛选</el-button>
              <el-button @click="reset">重置</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="table-conter">
          <div class="addNew">
            <el-button type="primary" @click="addnew(false)">新建积分规则</el-button>
          </div>
          <div class="table-list">
            <el-table
              v-loading="tableLoading"
              :data="tableData"
              :header-cell-style="{
                background: '#fff',
                color: '#303133',
                fontWeight: '100',
                height: '60px',
              }"
            >
              <template slot="empty">
                <div class="table-noData">
                  <img
                    class="table-noData-img"
                    src="https://baike-med-1256891581.file.myqcloud.com/2021034/c03485a0-8608-11eb-947c-032fa08bea6e_0.png"
                    style="width: 50%; height: 300px"
                  />
                  <div class="table-noData-word">暂无相关内容</div>
                </div>
              </template>
              <el-table-column
                label="顺序"
                align="center"
                type="index"
                :index="indexMethod"
                width="80px"
              />
              <el-table-column label="用户角色" min-width="15%">
                <template slot-scope="scope">
                  <span>{{ scope.row.CustomType === 1 ? '员工' : '医生' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="用户行为" min-width="15%">
                <template slot-scope="scope">
                  <span>{{ BehaviorTypeData[scope.row.BehaviorType] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="完成时限" min-width="15%">
                <template slot-scope="scope">
                  <span v-if="scope.row.TimeLimit">文章发布 {{ scope.row.TimeLimit }} 天内</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="TargetAddress" label="指定地址" min-width="20%">
                <template slot-scope="scope">
                  <span v-if="scope.row.TargetAddress">{{ scope.row.TargetAddress }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="获取分值" min-width="15%">
                <template slot-scope="scope">
                  <span>{{ scope.row.Scores > 0 ? '+' : '' }}{{ scope.row.Scores }}</span>
                </template>
              </el-table-column>
              <el-table-column label="每日积分上限" min-width="15%">
                <template slot-scope="scope">
                  <span>{{ scope.row.SupperLimit > 0 ? '+' : '' }}{{ scope.row.SupperLimit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="15%">
                <template slot-scope="scope">
                  <div style="display: flex">
                    <el-button
                      type="text"
                      @click="addnew(scope.row.ID)"
                      style="font-size: 16px; margin-left: 10px"
                    >
                      编辑
                    </el-button>
                    <!-- 待审核事件 -->
                    <el-button
                      type="text"
                      @click="deleteAction(scope.row.ID)"
                      style="font-size: 16px; margin-left: 10px"
                    >
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryParams.PageNum"
              :page-size="queryParams.PageSize"
              layout="total,sizes, prev, pager, next, jumper"
              :total="totalVal"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="积分规则页面配置" name="second">
        <div class="rules-page">
          <div class="top">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="164px"
              class="demo-ruleForm"
            >
              <el-form-item label="积分规则页面跳转链接" prop="name">
                <el-input
                  :disabled="showWidth"
                  v-model="ruleForm.UrlPath"
                  placeholder="请输入查看积分规则H5页面的跳转链接"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="bottom">
            <div class="edit-box" v-show="showWidth">
              <el-button @click="changeShowWidth(true)">编辑</el-button>
            </div>
            <div class="edit-box" v-show="!showWidth">
              <el-button style="margin-right: 20px" @click="changeShowWidth(false)">取消</el-button>
              <el-button :disabled="!ruleForm.UrlPath" type="primary" @click="saveUrlPath">
                保存
              </el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 删除 -->
    <Dialog
      title="删除积分规则"
      :visible="delDialogVisible"
      width="400px"
      @submitPopupData="delAction"
      @resetPopupData="delCloseDialog"
      @handleClose="delCloseDialog"
      button-type="danger"
    >
      <template slot>
        <span style="margin-left: 30px">确定删除该项积分规则吗？</span>
      </template>
    </Dialog>
  </div>
</template>
<script>
//  引用 table静态资源
import Dialog from '../../components/dialog/index.vue';
import {
  GetCreditRuleListReq,
  DelCreditRuleReq,
  GetCreditRuleUrlReq,
  SetCreditRuleUrlReq,
  GetBehaviorListReq,
} from '../../api/pointsRule';
const { useRole, userBehaviorList, tableData, BehaviorTypeData } = require('./index');
export default {
  name: 'PointsRuleManagement',
  components: { Dialog },
  data() {
    const validCodeName = (rule, value, callback) => {
      /* eslint-disable */ const reg = /^((https?|ftp|news):\/\/)?([a-z]([a-z0-9\-]*[\.。])+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel)|(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))(\/[a-z0-9_\-\.~]+)*(\/([a-z0-9_\-\.]*)(\?[a-z0-9+_\-\.%=&]*)?)?(#[a-z][a-z0-9_]*)?$/;
      if (!this.ruleForm.UrlPath) {
        callback(new Error('请输入跳转链接ID'));
      } else if (!reg.test(this.ruleForm.UrlPath)) {
        callback(new Error('请输入正确的跳转链接ID'));
      } else {
        callback();
      }
    };
    return {
      activeName: 'first',
      useRole, // 角色选择按钮列表
      userBehaviorList, // 角色行为列表
      // 列表请求接口参数
      queryParams: {
        PageNum: 1, // 当前页数
        PageSize: 10, // 每页条数
        BehaviorType: '', // 用户行为类型
        CustomType: '', // 用户校色类型
      },
      tableData, // 列表数据
      tableLoading: false, // 是否显示加载
      BehaviorTypeData, // 用户行为显示判断列表
      delDialogVisible: false, // 删除弹窗是否显示
      delId: '', // 删除对象的ID
      totalVal: 1, // 数据总条数
      showWidth: false, // 展示编辑还是保存
      ruleForm: {
        UrlPath: '', // 积分查看地址
      },
      rules: {
        name: [
          // { required: true, message: '请输入跳转链接ID', trigger: 'blur' },
          { validator: validCodeName, trigger: 'blur' },
        ],
      },
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.getList();
    this.getBehaviorList();
  },
  methods: {
    // // 获取需要的数据
    getneewList() {
      return Promise.all([this.getList(), this.getBehaviorList()]);
    },
    // 获取用户行为类型列表
    getBehaviorList() {
      GetBehaviorListReq({})
        .then((res) => {
          this.userBehaviorList = []; // 先清空
          const data = res.Datas;
          // 将用户行为赋值给下拉选择框，用于数据筛选
          this.userBehaviorList = data;
          this.userBehaviorList.unshift({
            BehaviorTypeName: '全部用户行为',
            BehaviorTypeID: 0,
          });
          // 将返回行为转为需要的对象，用于列表展示队医你个的用户行为
          const list = [];
          this.userBehaviorList.forEach((item) => {
            list.push(item.BehaviorTypeName);
          });
          this.BehaviorTypeData = { ...list };
          this.queryParams.BehaviorType = this.userBehaviorList[0].BehaviorTypeID;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleClick(tab, event) {
      // 页签切换
      if (tab.name === 'second') {
        this.getPointsRules();
        this.showWidth = false;
      }
    },
    // 页码改变
    handleCurrentChange(page) {
      this.queryParams.PageNum = page;
      this.getList(1);
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.queryParams.PageSize = val;
      this.getList();
    },
    // 获取列表接口
    getList(val) {
      console.log(this.queryParams);
      const { PageNum } = this.queryParams;
      this.queryParams.PageNum = val ? PageNum : 1;
      this.tableLoading = true;
      GetCreditRuleListReq(this.queryParams)
        .then((res) => {
          const data = res?.Datas;
          this.tableData = data;
          this.totalVal = res?.Total;
          this.tableLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.tableLoading = false;
        });
    },
    // 重置事件
    reset() {
      this.queryParams.CustomType = '';
      this.queryParams.BehaviorType = 0;
      this.getList();
    },
    indexMethod(index) {
      let curpage = this.queryParams.PageNum; //单前页码，具体看组件取值
      let limitpage = this.queryParams.PageSize; //每页条数，具体是组件取值
      return index + (curpage - 1) * limitpage + 1;
    },
    // 新建积分规则
    addnew(id) {
      if (id) {
        // 前往编辑
        this.g_tourl(`/saas/huizhi/PointsRule/edit.html?id=${id}`);
        return;
      } // 前往新建
      this.g_tourl(`/saas/huizhi/PointsRule/edit.html`);
    },
    // 删除
    deleteAction(id) {
      console.log(id);
      this.delId = id;
      this.delDialogVisible = true;
    },
    // 确认删除
    delAction() {
      const parmas = {
        ID: this.delId,
      };
      DelCreditRuleReq(parmas)
        .then((res) => {
          console.log(res);
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.delDialogVisible = false;
          this.getList();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 删除弹窗关闭
    delCloseDialog() {
      this.delId = '';
      this.delDialogVisible = false;
    },
    // 获取积分规则查看网址
    getPointsRules() {
      GetCreditRuleUrlReq({})
        .then((res) => {
          this.ruleForm.UrlPath = res?.UrlPath;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 点击更改显示
    changeShowWidth(val) {
      this.showWidth = !this.showWidth;
      if (!val) {
        this.$refs.ruleForm.resetFields();
        this.getPointsRules();
      }
    },
    // 保存规则地址
    saveUrlPath() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const parmas = {
            UrlPath: this.ruleForm.UrlPath,
          };
          SetCreditRuleUrlReq(parmas)
            .then((res) => {
              console.log(res);
              this.showWidth = true;
              this.$message({
                message: '设置成功',
                type: 'success',
              });
            })
            .catch((res) => {
              console.log(res);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import './index.scss';
</style>
